// extracted by mini-css-extract-plugin
module.exports = {"inspectCarInfo":"InspectCarInfo_inspectCarInfo__3c4Js","border":"InspectCarInfo_border__32kBq"};